module.exports = __webpack_public_path__ + "static/slide-5-2a101b703fca2f933366b627a17476a4.png";